import React, { useCallback } from 'react';
import { Form, Formik } from 'formik';
import { useNavigate } from 'react-router-dom';

import { createLocale } from 'locales';

import Typography from 'components-new/typography/typography';

import SubmitButton from 'form-elements/submit-button';
import PasswordField from 'form-elements/password-field';

import useFreelancerConfirmResetPassword from 'state/remote/remote-freelancer/use-freelancer-confirm-reset-password';

import FreelancerSignUpPageContainer from '../components/freelancer-sign-up-page-container';
import freelancerRoutes from '../freelancer-routes';

import resetPasswordFormValidate from './schema';

const freelancerResetPasswordLocalize = createLocale(
  'freelancerResetPasswordLocales',
);
const globalLocalize = createLocale('global');

const ResetPassword = (): JSX.Element => {
  const navigate = useNavigate();
  const { resetPassword, initialValues } = useFreelancerConfirmResetPassword();

  const onResetPasswordClicked = useCallback(
    (values: Parameters<typeof resetPassword>[0]) => {
      resetPassword(values);
      navigate(freelancerRoutes.login.path);
    },
    [resetPassword, navigate],
  );

  return (
    <FreelancerSignUpPageContainer
      showHeader
      headerTitle={freelancerResetPasswordLocalize('title')}
      className="flex flex-col items-center"
    >
      <Formik
        initialValues={initialValues}
        validationSchema={resetPasswordFormValidate}
        onSubmit={onResetPasswordClicked}
      >
        <Form className="mb-16 w-full">
          <Typography
            as="p"
            variant="body-medium"
            className="text-gray500 mt-4"
          >
            {freelancerResetPasswordLocalize('enterNewPassword')}
          </Typography>

          <PasswordField
            name="new_password1"
            type="password"
            className="w-full mt-8"
            title={globalLocalize('password')}
          />
          <PasswordField
            name="new_password2"
            type="password"
            className="w-full mt-2"
          />
          <SubmitButton
            type="submit"
            label={freelancerResetPasswordLocalize('resetPassword')}
            variant="primary"
            className="w-full justify-center mt-10"
          />
        </Form>
      </Formik>
    </FreelancerSignUpPageContainer>
  );
};

export default ResetPassword;
